<template>
  <div>
    <div class="centered">
      <h4 class="ViewHeading">
        Risk Assessment: {{ this.LinkedRiskAssessment }} - Review
      </h4>
    </div>
    <div>
      <b-card>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <br />
        <b-row>
          <b-col cols="3"> Risk Assessor: </b-col>
          <b-col cols="3">{{ AssessmentObject.Details.Assessor }}</b-col>
          <b-col cols="3"> Assessment Type: </b-col>
          <b-col cols="3">{{ AssessmentObject.Details.ServiceNote }}</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="2">Commence Date: </b-col>
          <b-col cols="4">{{ AssessmentObject.Details.Date }} </b-col>
          <b-col cols="2">Commence Time: </b-col>
          <b-col cols="4">{{ AssessmentObject.Details.Time }} </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="3">Location: </b-col>
          <b-col cols="6">{{ this.LinkedRiskLocation }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="3"> Room/Area: </b-col>
          <b-col cols="6">{{ AssessmentObject.Details.Room }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="3"> Location Note: </b-col>
          <b-col cols="9">{{ AssessmentObject.Details.LocationNote }}</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="3"> Contact Name: </b-col>
          <b-col cols="6">{{ AssessmentObject.Details.ContactName }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="3"> Contact Email: </b-col>
          <b-col cols="6">{{ AssessmentObject.Details.ContactEmail }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="3"> Contact Note: </b-col>
          <b-col cols="9">{{ AssessmentObject.Details.ContactNote }}</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="3">Risk Assessment Category:</b-col>
          <b-col cols="6">{{ AssessmentObject.Details.Environment }}</b-col>
        </b-row>
        <br />
      </b-card>
    </div>
    <div class="centered">
      <h4 class="ViewHeading">Attachments</h4>
    </div>

    <b-card no-body>
      <b-card-body>
        <b-row v-if="AssessmentObject.Documents.length > 0" class="actionrow">
          <b-col cols="2" class="headercol">Type</b-col>
          <b-col cols="5" class="headercol">Name</b-col>
          <b-col cols="2" class="headercol">Upload Date</b-col>
          <b-col cols="2" class="headercol">Upload Time</b-col>
          <b-col cols="1" class="headercol"></b-col
        ></b-row>
        <b-row v-if="AssessmentObject.Documents.length == 0">
          <b-col class="text-center"
            >No attachments included with Risk Assessment</b-col
          >
        </b-row>
        <b-row
          v-for="(Document, id) in AssessmentObject.Documents"
          :key="id"
          class="actionrow"
        >
          <b-col cols="2" class="bodycol">{{ Document[3] }}</b-col>
          <b-col cols="5" class="bodycol">{{ Document[2] }}</b-col>
          <b-col cols="2" class="bodycol">{{ Document[0] }}</b-col>
          <b-col cols="2" class="bodycol">{{ Document[1] }}</b-col>
          <b-col cols="1" class="bodycol">
            <b-button
              size="sm"
              variant="outline-info"
              v-on:click="DownloadQuestionnaire(Document[2])"
              ><BIconDownload></BIconDownload
            ></b-button>
          </b-col>
        </b-row>
        <br />
      </b-card-body>
    </b-card>
    <div>
      <hr />
      <div class="centered">
        <h4 class="ViewHeading">Findings & Recommendations</h4>
      </div>
      <br />
      <b-row>
        <b-col>
          <h5>Findings</h5>
        </b-col>
      </b-row>

      <b-form-textarea
        id="RAFindings"
        v-model="AssessmentObject.Findings"
        no-resize
        placeholder="Please enter findings here. If no actions or findings please complete with appropriate statement"
        rows="3"
        max-rows="3"
        readonly
      ></b-form-textarea>
      <br />
      <b-row>
        <b-col>
          <h5>Recommendations</h5>
        </b-col>
      </b-row>

      <b-form-textarea
        id="RARecommendations"
        v-model="AssessmentObject.Recommendations"
        no-resize
        placeholder="Please enter recommendations here. If no recommendations please complete with appropriate statement"
        rows="3"
        max-rows="3"
        readonly
      ></b-form-textarea>
    </div>
    <hr />
    <div class="centered">
      <h4 class="ViewHeading">Risks & Actions</h4>
    </div>
    <br />
    <div>
      <b-row>
        <b-col>
          <h5>Risks</h5>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-card-body>
          <b-row v-if="AssessmentObject.Risks.length > 0" class="actionrow">
            <b-col cols="3" class="headercol">Risk Category</b-col>
            <b-col cols="3" class="headercol">Risk Level</b-col>
            <b-col cols="5" class="headercol">Risk Note</b-col>
            <b-col cols="1" class="headercol"></b-col
          ></b-row>
          <b-row v-if="AssessmentObject.Risks.length == 0">
            <b-col class="text-center"
              >No Risks identified during Risk Assessment</b-col
            >
          </b-row>
          <b-row
            v-for="(Risk, id) in AssessmentObject.Risks"
            :key="id"
            class="actionrow"
          >
            <b-col cols="3" class="bodycol">{{ Risk[0] }}</b-col>
            <b-col cols="3" class="bodycol">{{ Risk[1] }}</b-col>
            <b-col cols="5" class="bodycol">{{ Risk[2] }}</b-col>
          </b-row>
          <br />
        </b-card-body>
      </b-card>
      <br />
      <b-row>
        <b-col>
          <h5>Remedial Actions</h5>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-card-body>
          <b-row class="actionrow">
            <b-col class="headercol" cols="2">Action Type</b-col>
            <b-col class="headercol" cols="4">Description</b-col>
            <b-col class="headercol" cols="2">Due Date</b-col>
            <b-col class="headercol" cols="1">Dept</b-col>
            <b-col class="headercol" cols="2">Note</b-col>
            <b-col cols="1" class="headercol"></b-col>
          </b-row>
          <b-row v-if="this.NewActionsList.length == 0">
            <b-col class="text-center"
              >No Current Actions for this Risk Assessment</b-col
            >
          </b-row>
          <b-row
            v-for="(NewAction, id) in this.NewActionsList"
            :key="id"
            class="actionrow"
          >
            <b-col class="bodycol" cols="2">{{ NewAction.Type }}</b-col>
            <b-col class="bodycol" cols="4">{{ NewAction.Description }}</b-col>
            <b-col class="bodycol" cols="2">{{ NewAction.Deadline }}</b-col>
            <b-col class="bodycol" cols="1">{{
              NewAction.Responsibility
            }}</b-col>
            <b-col class="bodycol" cols="2">{{ NewAction.Note }}</b-col>
            <b-col cols="1" class="bodycol"
              ><b-button
                variant="outline-danger"
                size="sm"
                v-on:click="removeAction(id)"
                ><BIconXSquare></BIconXSquare></b-button
            ></b-col>
          </b-row>
          <br />
        </b-card-body>
      </b-card>
      <b-row>
        <b-col
          ><b-button
            variant="outline-success"
            size="sm"
            v-on:click="addNewAction()"
            ><BIconPlusSquare></BIconPlusSquare> New Action</b-button
          ></b-col
        >
      </b-row>
      <br />
      <b-row>
        <b-col cols="12" class="text-center"
          ><b-button
            variant="outline-info"
            size="sm"
            v-on:click="SaveReviewedSurvey()"
            >Submit Review</b-button
          >
          <b-button variant="outline-info" size="sm" v-on:click="CancelReview()"
            >Cancel Review</b-button
          >
        </b-col>
      </b-row>
      <hr />
    </div>
    <b-modal
      ref="AddActionModal"
      id="AddActionModal"
      title="Remedial Action for Risk Assessment"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <div>
          <b-row>
            <b-col cols="4" class="text-left">Risk Assessment</b-col>
            <b-col cols="8">{{ NewAction.LinkedID }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Action Type</b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Type"
            /></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Due Date </b-col>
            <b-col cols="8"
              ><b-form-datepicker
                v-model="NewAction.Deadline"
              ></b-form-datepicker>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Responsibility </b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Responsibility"
            /></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Description</b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Description"
            /></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Note </b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Note"
            /></b-col>
          </b-row>
          <br />
          <b-row
            ><b-col
              ><b-button
                size="sm"
                variant="outline-info"
                v-on:click="SubmitActionModal()"
                >Save Action</b-button
              ></b-col
            >
            <b-col
              ><b-button
                size="sm"
                variant="outline-info"
                v-on:click="CancelActionModal()"
                >Cancel Action</b-button
              ></b-col
            ></b-row
          >
        </div>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BIconPlusSquare,
  BIconXSquare,
  BIconDownload,
} from "bootstrap-vue/dist/bootstrap-vue.esm";
import { riskDirectDownloadByKey } from "@/Services/aws.js";
import axios from "axios";

export default {
  computed: {},
  components: {
    BIconXSquare,
    BIconPlusSquare,
    BIconDownload,
  },

  data() {
    return {
      LinkedRiskAssessment: this.$LinkedRisk,
      LinkedRiskLocation: this.$LinkedRiskLocation,
      name: localStorage.getItem("fullname"),
      selectedlocation: localStorage.getItem("CurrentLocation"),
      NewAction: {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        LinkedID: null,
        Note: null,
      },
      NewActionsList: [],
      ActionListFields: [
        { key: "Type", label: "Action Type", variant: "primary" },
        { key: "Description", label: "Description" },
        { key: "Deadline", label: "Due Date" },
        { key: "Responsibility", label: "Responsibility" },
        { key: "LinkedID", label: "Risk Assessment" },
        { key: "Note", label: "Note" },
        { key: "Action", label: "" },
      ],
      AssessmentObject: {
        Details: {
          ID: null,
          Assessor: null,
          Environment: null,
          Room: null,
          Date: null,
          Time: null,
          LocationNote: null,
          ServiceNote: null,
          ArrangedBy: null,
          ContactName: null,
          ContactEmail: null,
          ContactNote: null,
        },
        Findings: null,
        Recommendations: null,
        Risks: [],
        Documents: [],
      },
      detailsarray: [],
    };
  },

  beforeMount() {},

  mounted() {
    let DetailsLookupURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let DetailsLookupHeaders = this.$apikeyPost;
    let DetailsLookupRequest = {
      ServiceType: "RiskAssessment",
      RequestType: "RiskAssessmentDetails",
      DataDict: [
        {
          AssessmentID: this.LinkedRiskAssessment,
        },
      ],
    };
    axios
      .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
      .then((response) => {
        this.detailsarray = [];
        this.detailsarray = response.data.Values;
        this.LinkedRiskAssessment = this.detailsarray[0];
        this.AssessmentObject.Details.ID = this.detailsarray[0];
        this.AssessmentObject.Details.Assessor = this.detailsarray[8];
        this.AssessmentObject.Details.Environment = this.detailsarray[5];
        this.AssessmentObject.Details.Room = this.detailsarray[2];
        this.AssessmentObject.Details.Date = this.detailsarray[6];
        this.AssessmentObject.Details.Time = this.detailsarray[7];
        this.AssessmentObject.Details.LocationNote = this.detailsarray[3];
        this.AssessmentObject.Details.ServiceNote = this.detailsarray[4];
        this.AssessmentObject.Details.ContactName = this.detailsarray[9];
        this.AssessmentObject.Details.ContactEmail = this.detailsarray[10];
        this.AssessmentObject.Details.ContactNote = this.detailsarray[11];
        this.AssessmentObject.Findings = this.detailsarray[12];
        this.AssessmentObject.Recommendations = this.detailsarray[13];
        this.AssessmentObject.Risks = this.detailsarray[14];
        this.AssessmentObject.Documents = this.detailsarray[15];
        // this.MakePDFReadOnly();
      });
  },

  methods: {
    MakePDFReadOnly() {
      for (var i = 0; i < this.AssessmentObject.Documents.length; i++) {
        let DetailsLookupURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/s3";
        let DetailsLookupHeaders = this.$apikeyPost;
        let DetailsLookupRequest = {
          RequestType: "MakePDFReadOnly",
          DataDict: [
            {
              AssessmentID: this.LinkedRiskAssessment,
              Location: this.detailsarray[1],
              FileName: this.AssessmentObject.Documents[i][2],
            },
          ],
        };
        axios
          .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
          .then((response) => {
            response;
          });
      }
    },

    addNewAction() {
      (this.NewAction = {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        LinkedID: this.LinkedRiskAssessment,
        Note: null,
      }),
        this.$refs["AddActionModal"].show();
    },
    removeAction(item) {
      this.NewActionsList.splice(item, 1);
      alert("remove this action");
    },
    CancelActionModal() {
      this.$refs["AddActionModal"].hide();
    },
    SubmitActionModal() {
      this.NewActionsList.push(this.NewAction);

      alert("Action Added to List");
      this.$refs["AddActionModal"].hide();
      this.NewAction = {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        LinkedID: this.LinkedRiskAssessment,
        Note: null,
      };
    },
    SaveReviewedSurvey() {
      let SaveReviewURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let SaveReviewHeaders = this.$apikeyPost;
      let SaveReviewRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "VerifyRiskAssessment",
        DataDict: [
          {
            AssessmentID: this.LinkedRiskAssessment,
            ActionsList: this.NewActionsList,
            VerifiedBy: this.name,
          },
        ],
      };
      axios
        .post(SaveReviewURL, SaveReviewRequest, SaveReviewHeaders)
        .then((response) => {
          response;
          alert("Risk Assessment Review Completed");
        });

      this.NewAction = {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        LinkedID: this.LinkedRiskAssessment,
        Note: null,
      };
      this.NewActionsList = [];
      this.$emit("RevEvent", "ReviewComplete");
    },

    async DownloadQuestionnaire(id) {
      let filekey = "";
      filekey =
        this.LinkedRiskLocation +
        "/Risk Assessments/" +
        this.LinkedRiskAssessment +
        "/" +
        id;
      let attachment = filekey;
      const res = await riskDirectDownloadByKey(attachment);

      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filekey); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    },
    CancelReview() {
      this.$emit("RevEvent", "ReviewComplete");
    },
  },
};
</script>

<style>
input {
  width: 100%;
}

.headercol {
  border-bottom: solid 2px lightgrey;
  font-weight: bold;
  margin: 0;
  padding: 5px;
}
.bodycol {
  padding: 5px;
}
.actionrow {
  margin-left: auto;
  margin-right: auto;
}

.centered {
  text-align: center;
}
</style>
